// extracted by mini-css-extract-plugin
export default {"card":"EY-z","carouselContainer":"FY-z","carouselContent":"GY-z"};